import { css } from '@emotion/css';

export const addChapterBlock = css`
	display: flex;
	justify-content: space-between;
`;
